import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';

const siteTheme = extendTheme({
  fonts: {
    heading: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    body: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  styles: {
    global: {
      html: { scrollBehavior: 'smooth' },
      body: { bg: '#111827', color: '#F4F4F6' },
      '::selection': { bg: '#00FFD0', color: '#081018' },
      '@media (prefers-reduced-motion: reduce)': {
        '*, *::before, *::after': {
          scrollBehavior: 'auto !important',
          animationDuration: '0.01ms !important',
          animationIterationCount: '1 !important',
          transitionDuration: '0.01ms !important',
        },
      },
    },
  },
  components: {
    Button: { baseStyle: { fontWeight: '700', transition: 'all 0.2s ease' } },
    Link: { baseStyle: { transition: 'all 0.2s ease' } },
  },
});

createRoot(document.getElementById('root')).render(
  <ChakraProvider theme={siteTheme}>
    <App />
  </ChakraProvider>
);
